import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgLocationCircle = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <circle
          id="ui__icons__inline__location-circle_svg__a"
          cx={10}
          cy={10}
          r={10}
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="ui__icons__inline__location-circle_svg__b" fill="#fff">
          <use xlinkHref="#ui__icons__inline__location-circle_svg__a" />
        </mask>
        <circle cx={10} cy={10} r={9.5} stroke="currentColor" />
        <g mask="url(#ui__icons__inline__location-circle_svg__b)">
          <g transform="translate(5 2.619)">
            <path
              fill="currentColor"
              d="M9.932 6.96c-.002 0 .17-.469.282-1.043v-.562c0-2.726-2.278-4.936-5.107-4.936S0 2.63 0 5.355v.554c.112.579.254 1.052.252 1.052.002.03.108.265.238.542.13.276.88 1.439 1.24 2.063l2.696 4.685c.36.624.947.624 1.306 0L8.43 9.565c.36-.624 1.118-1.796 1.253-2.083.136-.287.252-.521.25-.521z"
            />
            <circle cx={4.95} cy={5.369} r={2.75} fill="#FFF" />
          </g>
        </g>
      </g>
    </svg>
  );
};
export default SvgLocationCircle;
